<span class="text-nowrap">{{currency}}</span>
<span *ngIf="currencyDescription && showDescription">
  <br />
  <small class="text-muted">{{currencyDescription}}</small>
</span>